import WeekDay from '~/models/types/WeekDay';

export const weekdays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export default function getCurrentDay(): WeekDay {
  const now = new Date();
  const currentDay = weekdays[now.getDay()];

  return currentDay as WeekDay;
}
